module.exports = __webpack_public_path__ + "img/加拿大站.56572164.png";